"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[347],{

/***/ 8768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FeaturedNews; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/swiper/esm/react/swiper.js + 8 modules
var swiper = __webpack_require__(9447);
// EXTERNAL MODULE: ./node_modules/swiper/esm/react/swiper-slide.js
var swiper_slide = __webpack_require__(4002);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/core/core-class.js + 66 modules
var core_class = __webpack_require__(172);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/navigation/navigation.js
var navigation = __webpack_require__(5186);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/pagination/pagination.js
var pagination = __webpack_require__(2997);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/autoplay/autoplay.js
var autoplay = __webpack_require__(7649);
// EXTERNAL MODULE: ./src/components/Layout/WrapperDestaque/index.tsx
var WrapperDestaque = __webpack_require__(248);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/hub.js + 9 modules
var hub = __webpack_require__(5877);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/utils/className.ts
var className = __webpack_require__(9659);
// EXTERNAL MODULE: ./src/components/Layout/Image/index.tsx + 1 modules
var Image = __webpack_require__(2153);
;// CONCATENATED MODULE: ./src/components/Home/FeaturedNews/NewsContent/index.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */ 



function FeaturedNewsTitle(param) {
    var url = param.url, eye = param.eye, title = param.title, imageURL = param.imageURL, blurhash = param.blurhash, featured = param.featured;
    var variants = {
        ContainerNewsTitle: {
            featured: {
                true: "desktop:[&_span]:text-base [&_span]:text-xs [&_span]:font-medium  desktop:[&_h2]:text-2xl [&_h2]:text-xl [&_h2]:font-medium",
                false: "[&_span]:text-xs [&_h2]:text-xl"
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: url,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: "h-full w-full cursor-pointer last:[&>div]:hover:scale-105",
            title: title,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,className/* default */.Z)("absolute bottom-0 z-[3] block w-full p-6 text-left text-mglGray50", variants.ContainerNewsTitle.featured[featured.toString()]),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "mb-[10.24px] block font-medium uppercase text-mglGray50",
                            children: eye
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "mb-[unset] block transform-none text-left font-medium text-mglGray50",
                            children: title
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative h-full w-full transition-transform duration-300 ease-ease before:absolute before:bottom-0 before:left-0 before:right-0 before:top-0 before:z-[2] before:rounded before:content-[''] before:[background:linear-gradient(200deg,_rgba(34,_34,_34,_0)_0%,_rgba(34,_34,_34,_0.8)_100%)]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: imageURL,
                        alt: title,
                        blurhash: blurhash
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/Layout/EditorialSectionLogo/index.tsx


/**
 * Header de identidade da editoria nas seções de home/listagem: a logo da
 * editoria (data-driven, do Directus) centralizada sobre a caixa já colorida
 * pela cor de marca. Substitui o header hardcoded por marca
 * (`EditorialCategorySponsorBanner`). Sem logo → não renderiza nada.
 */ function EditorialSectionLogo(param) {
    var editoria = param.editoria, _isFeatured = param.isFeatured, isFeatured = _isFeatured === void 0 ? false : _isFeatured;
    var ref;
    var logoUrl = (ref = editoria.logo) === null || ref === void 0 ? void 0 : ref.url;
    if (!logoUrl) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,className/* default */.Z)("flex items-center justify-center", isFeatured ? "py-4" : "p-4"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: "/".concat(editoria.slug, "/"),
            title: editoria.nome,
            className: "flex items-center [&>img]:h-8",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: logoUrl,
                alt: editoria.nome,
                className: "h-8 w-auto object-contain"
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/components/Home/FeaturedNews/index.tsx










var SponsorBanner = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8814).then(__webpack_require__.bind(__webpack_require__, 4554));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4554)
            ];
        }
    }
});
core_class/* default.use */.Z.use([
    navigation/* default */.Z,
    pagination/* default */.Z,
    autoplay/* default */.Z
]);
var FeaturedNews_pagination = {
    clickable: true
};
var FeaturedNews_navigation = {
    nextEl: "#destaque-container-area__next",
    prevEl: "#destaque-container-area__prev"
};
// Tema data-driven da editoria: fundo = `--tarja-bg` (cor primária), acento
// (botões do swiper + bullet ativo) = `--tarja-accent` (cor secundária). As cores
// vêm do Directus por editoria; a regra é uniforme (o legado tinha uma variante
// hardcoded por marca). Compound `.hasTarja` eleva a especificidade sobre os
// defaults neutros.
var TARJA_VARIANT = "hasTarja [&.hasTarja]:bg-[var(--tarja-bg)] [&_.swiper-button]:[&.hasTarja]:bg-[var(--tarja-accent)] [&_.swiper-button]:[&.hasTarja]:text-mglGray50 [&_.swiper-pagination-bullet]:[&.hasTarja]:bg-mglGray50 [&_span.swiper-pagination-bullet-active]:[&.hasTarja]:bg-[var(--tarja-accent)]";
// Variantes hardcoded legadas (fallback de sub-categoria — ver comentário na prop).
var LEGACY_VARIANT = {
    ctup: "hasTarja [&.hasTarja]:bg-ctupBlue [&_.swiper-button]:[&.hasTarja]:bg-ctupCyan [&_.swiper-pagination-bullet]:[&.hasTarja]:bg-mglGray50 [&_span.swiper-pagination-bullet-active]:[&.hasTarja]:bg-ctupCyan",
    eletro: "hasTarja [&.hasTarja]:bg-cteletroBlack [&_.swiper-button]:[&.hasTarja]:bg-cteletroGreen [&_.swiper-pagination-bullet]:[&.hasTarja]:bg-mglGray50 [&_span.swiper-pagination-bullet-active]:[&.hasTarja]:bg-cteletroGreen",
    ctauto: "hasTarja [&.hasTarja]:bg-ctautoRed [&_.swiper-button]:[&.hasTarja]:bg-mglGray50 [&_.swiper-button]:[&.hasTarja]:text-ctautoBlack [&_.swiper-pagination-bullet]:[&.hasTarja]:bg-mglGray50 [&_span.swiper-pagination-bullet-active]:[&.hasTarja]:bg-ctautoBlack"
};
function FeaturedNews(param) {
    var featuredNewsData = param.featuredNewsData, _editoria = param.editoria, editoria = _editoria === void 0 ? undefined : _editoria, _editorialCategory = param.editorialCategory, editorialCategory = _editorialCategory === void 0 ? undefined : _editorialCategory;
    var ref, ref1;
    var currentSpan = (ref = (0,hub/* getCurrentHub */.Gd)().getScope()) === null || ref === void 0 ? void 0 : ref.getSpan();
    var featuredNewsSpan = currentSpan && currentSpan.startChild({
        op: "featuredNews"
    });
    // Data-driven vence; exige identidade COMPLETA (logo + cor) pra tematizar —
    // alinhado ao gate da tarja interna (sem logo → sem tema). Só cor, sem logo,
    // NÃO pinta a seção. Sem identidade completa, cai no fallback legado por slug.
    var theme = (editoria === null || editoria === void 0 ? void 0 : (ref1 = editoria.logo) === null || ref1 === void 0 ? void 0 : ref1.url) && (editoria === null || editoria === void 0 ? void 0 : editoria.cor) ? editoria : null;
    var themeStyle = theme ? {
        "--tarja-bg": theme.cor,
        "--tarja-accent": theme.corSecundaria || theme.cor
    } : undefined;
    var legacyVariant = !theme && editorialCategory ? LEGACY_VARIANT[editorialCategory] : undefined;
    if (featuredNewsData && (featuredNewsData === null || featuredNewsData === void 0 ? void 0 : featuredNewsData.length) > 3) {
        var ref2, ref3;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperDestaque/* default */.Z, {
            themeBg: theme === null || theme === void 0 ? void 0 : theme.cor,
            editorialCategory: !theme ? editorialCategory : undefined,
            backgroundColor: "bg-mglGray50",
            children: [
                (featuredNewsData === null || featuredNewsData === void 0 ? void 0 : (ref2 = featuredNewsData[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.imagem) === null || ref3 === void 0 ? void 0 : ref3.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preload",
                        as: "image",
                        href: featuredNewsData === null || featuredNewsData === void 0 ? void 0 : featuredNewsData[0].imagem.url
                    })
                }),
                theme ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EditorialSectionLogo, {
                    editoria: theme,
                    isFeatured: true
                }) : editorialCategory && /*#__PURE__*/ (0,jsx_runtime.jsx)(SponsorBanner, {
                    variant: editorialCategory
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: themeStyle,
                    className: (0,className/* default */.Z)("relative block bg-mglGray50 [&_#destaque-container-area__next]:flex [&_#destaque-container-area__next]:h-auto [&_#destaque-container-area__next]:cursor-pointer [&_#destaque-container-area__next]:items-center [&_#destaque-container-area__prev]:flex [&_#destaque-container-area__prev]:h-auto [&_#destaque-container-area__prev]:cursor-pointer [&_#destaque-container-area__prev]:items-center [&_.container-swiper--next]:right-6 [&_.container-swiper--prev]:left-6 [&_.container-swiper]:z-[5] [&_.container-swiper]:opacity-100 [&_.container-swiper]:transition-opacity [&_.container-swiper]:duration-300 [&_.container-swiper]:ease-ease [&_.swiper-button]:hidden [&_.swiper-button]:desktop:flex [&_.swiper-pagination-bullet]:h-2 [&_.swiper-pagination-bullet]:w-2 [&_.swiper-pagination-bullet]:rounded-2xl [&_.swiper-pagination-bullet]:bg-black/20 [&_.swiper-pagination-bullet]:[transition:background-color_0.3s_0s,_width_0.2s_0.3s] [&_.swiper-pagination]:bottom-0 [&_.swiper-pagination]:pr-[8.333%] [&_.swiper-pagination]:text-right [&_.swiper-slide]:tablet:w-[30%] first-of-type:[&_.swiper-slide]:tablet:w-[60%] [&:not(&:first-child)]:[&_.swiper-slide]:pl-2 [&:not(&:last-child)]:[&_.swiper-slide]:pr-2 [&_span.swiper-pagination-bullet-active]:w-[26px] [&_span.swiper-pagination-bullet-active]:bg-mglBlue400 [&_span.swiper-pagination-bullet-active]:[transition:background-color_0.3s_0s,_width_0.2s_0.3s]", theme ? TARJA_VARIANT : legacyVariant),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper/* Swiper */.t, {
                            centeredSlides: true,
                            centeredSlidesBounds: true,
                            grabCursor: true,
                            pagination: FeaturedNews_pagination,
                            navigation: FeaturedNews_navigation,
                            preventClicks: false,
                            preventClicksPropagation: false,
                            speed: 1000,
                            breakpoints: {
                                320: {
                                    slidesPerView: 1
                                },
                                768: {
                                    initialSlide: 2,
                                    slidesPerView: "auto",
                                    slidesPerGroup: 3
                                }
                            },
                            children: featuredNewsData === null || featuredNewsData === void 0 ? void 0 : featuredNewsData.map(function(newData, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                                        className: "relative h-[480px] w-full overflow-hidden rounded-lg",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedNewsTitle, {
                                            featured: index === 0,
                                            eye: newData.categoria,
                                            title: newData.titulo,
                                            url: newData.url,
                                            imageURL: newData.imagem.url,
                                            blurhash: newData.imagem.blurhash
                                        })
                                    })
                                }, newData.url);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container-swiper container-swiper--prev",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "destaque-container-area__prev",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    id: "destaque-swiper-button__prev",
                                    className: "swiper-button",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        "aria-hidden": "true",
                                        focusable: "false",
                                        width: "1.5em",
                                        height: "1.5em",
                                        preserveAspectRatio: "xMidYMid meet",
                                        viewBox: "0 0 24 24",
                                        style: {
                                            verticalAlign: "-0.125em",
                                            transform: "rotate(180deg)"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M8.59 16.58L13.17 12L8.59 7.41L10 6l6 6l-6 6l-1.41-1.42z",
                                            fill: "currentColor"
                                        })
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container-swiper container-swiper--next",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "destaque-container-area__next",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    id: "destaque-swiper-button__next",
                                    className: "swiper-button",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        "aria-hidden": "true",
                                        focusable: "false",
                                        width: "1.5em",
                                        height: "1.5em",
                                        preserveAspectRatio: "xMidYMid meet",
                                        viewBox: "0 0 24 24",
                                        style: {
                                            verticalAlign: "-0.125em",
                                            transform: "rotate(360deg)"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M8.59 16.58L13.17 12L8.59 7.41L10 6l6 6l-6 6l-1.41-1.42z",
                                            fill: "currentColor"
                                        })
                                    })
                                })
                            })
                        }),
                        featuredNewsSpan && featuredNewsSpan.finish()
                    ]
                })
            ]
        });
    }
    return null;
}


/***/ }),

/***/ 2384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Chip; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9659);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6008);







var variants = {
    sizes: {
        small: "h-6",
        medium: "h-9",
        large: "h-12"
    },
    backgroundColor: {
        white: "chip-bg-color [&.chip-bg-color]:bg-mglGray50",
        black: "chip-bg-color [&.chip-bg-color]:bg-mglGray900",
        green: "chip-bg-color [&.chip-bg-color]:bg-mglGreen500"
    },
    color: {
        black: "text-mglGray900",
        white: "chip-color [&.chip-color]:text-mglGray50 [&.chip-color]:[&_svg]:fill-mglGray50"
    },
    hover: {
        white: "chip-hover-color hover:[&.chip-hover-color]:bg-mglGray50 hover:[&.chip-hover-color]:text-mglGray900 [&.chip-hover-color]:hover:[&_path]:fill-mglGray900",
        black: "chip-hover-color hover:[&.chip-hover-color]:bg-mglGray900 hover:[&.chip-hover-color]:text-mglGray50 [&.chip-hover-color]:hover:[&_path]:fill-mglGray50",
        gray: "chip-hover-color hover:[&.chip-hover-color]:bg-mglGray200 hover:[&.chip-hover-color]:text-mglGray900 [&.chip-hover-color]:hover:[&_path]:fill-mglGray900",
        green: "chip-hover-color hover:[&.chip-hover-color]:bg-mglGreen600 hover:[&.chip-hover-color]:text-mglGray50 [&.chip-hover-color]:hover:[&_path]:fill-mglGray50"
    },
    borderColor: {
        gray: "chip-border-color [&.chip-border-color]:border-mglGray900/20 hover:[&.chip-border-color]:border-mglGray50",
        black: "border-mglGray900/20",
        white: "chip-border-color [&.chip-border-color]:border-mglGray50/20",
        green: "chip-border-color [&.chip-border-color]:border-mglGreen500 hover:[&.chip-border-color]:border-mglGreen600"
    }
};
function Chip(param) {
    var texto = param.texto, prepIcon = param.prepIcon, posIcon = param.posIcon, _link = param.link, link = _link === void 0 ? "#" : _link, _color = param.color, color = _color === void 0 ? undefined : _color, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? undefined : _backgroundColor, backgroundImage = param.backgroundImage, _overlayOpacity = param.overlayOpacity, overlayOpacity = _overlayOpacity === void 0 ? 60 : _overlayOpacity, _chipSize = param.chipSize, chipSize = _chipSize === void 0 ? "small" : _chipSize, _borderColor = param.borderColor, borderColor = _borderColor === void 0 ? undefined : _borderColor, _title = param.title, title = _title === void 0 ? "" : _title, _highlightedText = param.highlightedText, highlightedText = _highlightedText === void 0 ? "" : _highlightedText, className = param.className, onClick = param.onClick, _hover = param.hover, hover = _hover === void 0 ? undefined : _hover, _rel = param.rel, rel = _rel === void 0 ? "" : _rel, _target = param.target, target = _target === void 0 ? "_self" : _target;
    var isValidLink = link[0] !== "#" && !/^\/\//.test(link) && link !== "";
    var Container = isValidLink ? (next_link__WEBPACK_IMPORTED_MODULE_2___default()) : react__WEBPACK_IMPORTED_MODULE_1__.Fragment;
    var Tag = link !== "#" && link !== "" ? "a" : "div";
    var linkProps = {};
    if (isValidLink) {
        Object.assign(linkProps, {
            href: link,
            passHref: true,
            prefetch: false
        });
    }
    var backgroundStyle = backgroundImage ? {
        backgroundImage: "linear-gradient(rgba(0, 0, 0, ".concat(overlayOpacity / 100, "), rgba(0, 0, 0, ").concat(overlayOpacity / 100, ")), url(").concat(backgroundImage, ")"),
        backgroundSize: "cover",
        backgroundPosition: "center"
    } : {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Container, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, linkProps), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Tag, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, link && link !== "#" && {
            href: link
        }), {
            className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("relative flex cursor-pointer flex-row flex-nowrap items-center justify-center overflow-hidden rounded-[100px] border border-solid px-4 no-underline transition-all ease-in [&_path]:transition-colors [&_path]:ease-ease", variants.sizes[chipSize], !backgroundImage && variants.backgroundColor[backgroundColor], variants.color[color], variants.borderColor[borderColor], variants.hover[hover], backgroundImage && "text-white", className),
            style: backgroundStyle,
            rel: rel,
            title: title,
            onClick: onClick,
            target: target,
            children: [
                !!prepIcon && typeof prepIcon === "string" && (prepIcon === "chevron-down" || prepIcon === "chevron-right") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "relative -m-1 flex pr-1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        icon: "mdi:".concat(prepIcon),
                        width: 16
                    })
                }) : !!prepIcon && typeof prepIcon !== "string" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "relative -m-1 flex pr-1",
                    children: prepIcon
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "relative mt-[-2px] whitespace-nowrap text-center text-xs no-underline",
                            children: texto
                        }),
                        !!highlightedText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "text-base font-semibold leading-none",
                            children: highlightedText
                        })
                    ]
                }),
                !!posIcon && typeof posIcon === "string" && (posIcon === "chevron-down" || posIcon === "chevron-right") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "relative -m-1 flex pl-1 [&_svg]:w-4",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        icon: "mdi:".concat(posIcon),
                        width: 16
                    })
                }) : !!posIcon && typeof posIcon !== "string" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "relative -m-1 flex pl-1",
                    children: posIcon
                })
            ]
        }))
    }));
}


/***/ }),

/***/ 1080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9659);


function Container(param) {
    var children = param.children, _hasBreadcrumb = param.hasBreadcrumb, hasBreadcrumb = _hasBreadcrumb === void 0 ? false : _hasBreadcrumb, _className = param.className, className = _className === void 0 ? "" : _className;
    var variants = {
        hasBreadcrumb: {
            true: "mt-4 desktop:mt-10",
            false: ""
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("w-full max-w-[calc(100%-2rem)] desktop:max-w-[83.33%]", variants.hasBreadcrumb[hasBreadcrumb.toString()], className),
        children: children
    });
}


/***/ }),

/***/ 2747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bL": function() { return /* binding */ BillboardContainer; },
/* harmony export */   "g1": function() { return /* binding */ AdContainer; },
/* harmony export */   "hn": function() { return /* binding */ ContentListNews; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9659);





var variants = {
    AdContainer: {
        noPadding: {
            true: "noPadding [&.noPadding]:p-0"
        },
        billboard: {
            true: "h-[250px] hidden tablet:flex"
        }
    },
    ContentListNews: {
        singleRow: {
            true: "grid-rows-[auto]"
        }
    }
};
var AdContainer = function(_param) {
    var children = _param.children, noPadding = _param.noPadding, billboard = _param.billboard, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children",
        "noPadding",
        "billboard"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("flex min-h-0 items-center justify-center bg-mglGray50 px-0 py-5", noPadding != undefined && variants.AdContainer.noPadding[noPadding.toString()], billboard != undefined && variants.AdContainer.billboard[billboard.toString()])
    }, rest), {
        children: children
    }));
};
var ContentListNews = function(_param) {
    var children = _param.children, singleRow = _param.singleRow, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children",
        "singleRow"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("ml-0 grid grid-cols-1 grid-rows-2 gap-5 [grid-auto-columns:1fr] tablet:ml-auto tablet:grid-cols-2 desktop:grid-cols-3 [&_a]:mx-0 [&_a]:my-5 [&_a]:no-underline ", singleRow != undefined && variants.ContentListNews.singleRow[singleRow.toString()])
    }, rest), {
        children: children
    }));
};
var BillboardContainer = function(_param) {
    var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: "m-0 hidden tablet:mx-[-8.335%] tablet:my-0 tablet:flex"
    }, rest), {
        children: children
    }));
};


/***/ }),

/***/ 2835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NewsTimeLine; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5877);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9659);
/* harmony import */ var _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9642);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2153);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6008);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_5__);
/* eslint-disable jsx-a11y/anchor-is-valid */ 







var publicRuntimeConfig = next_config__WEBPACK_IMPORTED_MODULE_5___default()().publicRuntimeConfig;
var icons = {
    video: "mdi:video",
    podcast: "mdi:microphone",
    webStories: "mdi:view-carousel"
};
function NewsTimeLine(param) {
    var news = param.news, _image = param.image, image = _image === void 0 ? true : _image, _effectImage = param.effectImage, effectImage = _effectImage === void 0 ? true : _effectImage, _title = param.title, title = _title === void 0 ? true : _title, propsTitle = param.propsTitle, _autor = param.autor, autor = _autor === void 0 ? false : _autor, propsAutor = param.propsAutor, metaInfo = param.metaInfo, propsMetaInfo = param.propsMetaInfo, _isSubDomain = param.isSubDomain, isSubDomain = _isSubDomain === void 0 ? false : _isSubDomain, _url = param.url, url = _url === void 0 ? null : _url, _headingTag = param.headingTag, headingTag = _headingTag === void 0 ? "h2" : _headingTag;
    var ref;
    var variants = {
        ItemList: {
            effectImage: {
                true: "[&_.image-container]:hover:scale-105",
                false: ""
            },
            colorInHover: {
                true: "transition-colors duration-300 ease-ease [&_h3]:hover:text-mglBlue400",
                false: ""
            }
        },
        Image: {
            imgRounded: {
                true: "rounded-half border-[3px] border-solid border-mglGray200",
                false: ""
            }
        },
        Title: {
            autorNoMargin: {
                true: "tablet:m-0 mt-0",
                false: ""
            }
        }
    };
    var currentSpan = (ref = (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_6__/* .getCurrentHub */ .Gd)().getScope()) === null || ref === void 0 ? void 0 : ref.getSpan();
    var newsListContainerSpan = currentSpan && currentSpan.startChild({
        op: "newsListContainer"
    });
    var Heading = headingTag;
    url || (url = news.url);
    if (isSubDomain && !url.match(/^https?:/)) {
        url = "".concat(publicRuntimeConfig.NEXT_PUBLIC_URL).concat(url);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("relative mx-0 mb-0 mt-4 hover:cursor-pointer tablet:my-4 [&_a]:text-[inherit]", propsTitle.altColorInHover && !!propsTitle.colorHover && variants.ItemList.colorInHover[(propsTitle.altColorInHover && !!propsTitle.colorHover).toString()], effectImage != undefined && variants.ItemList.effectImage[effectImage.toString()]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: url,
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                    rel: news.id,
                    title: news.titulo,
                    className: "jc",
                    children: [
                        image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "box relative flex overflow-hidden rounded-lg",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "image-container relative flex h-full w-full transition-transform duration-300 ease-ease [&>figure]:aspect-video",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        src: news.imagem.url,
                                        alt: news.titulo,
                                        blurhash: news.imagem.blurhash
                                    })
                                }),
                                autor && propsAutor && propsAutor.image && propsAutor.imgInImage && news.colunista && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "absolute bottom-2 left-2 h-10 w-10",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("h-auto w-full object-cover", propsAutor.imgRounded != null && variants.Image.imgRounded[propsAutor.imgRounded.toString()]),
                                        src: news.colunista.imagem.url,
                                        alt: news.autor,
                                        width: 40,
                                        height: 40
                                    })
                                }),
                                (news.tipo === "video" || news.tipo === "webStories" || news.tipo === "podcast") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "absolute bottom-[10px] left-[10px] z-[2] flex h-10 w-10 items-center justify-center rounded-half border-[6px] border-solid border-[#999] bg-[#999] text-[2.5rem]",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        icon: icons[news.tipo],
                                        width: "1em",
                                        color: _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_2__/* .mglGray.mglGray50 */ .Ce.mglGray50
                                    })
                                })
                            ]
                        }),
                        autor && propsAutor && propsAutor.image && !propsAutor.imgInImage && news.colunista && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "relative -bottom-2 mb-4 ml-0 mr-2 mt-0 inline-block h-10 w-10",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("h-auto w-full object-cover", propsAutor.imgRounded != null && variants.Image.imgRounded[propsAutor.imgRounded.toString()]),
                                src: news.colunista.imagem.url,
                                alt: news.autor
                            })
                        }),
                        autor && propsAutor && propsAutor.text && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "mx-0 mb-2 mt-4 inline-block text-xs text-black/40",
                            children: news.autor
                        }),
                        metaInfo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mb-[10px] mt-5 flex flex-row text-xs leading-none",
                            children: [
                                propsMetaInfo && propsMetaInfo.age && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: "flex flex-row items-center font-medium text-black/40 [&_svg]:mr-[2px]",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            icon: "mdi:clock-outline",
                                            width: "12",
                                            height: "12"
                                        }),
                                        news.idade
                                    ]
                                }),
                                propsMetaInfo && propsMetaInfo.age && propsMetaInfo.category && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mx-1 my-0 h-auto border-0 border-l-[0.5px] border-solid border-[#999]"
                                }),
                                propsMetaInfo && propsMetaInfo.category && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "font-medium uppercase text-black/40",
                                    children: news.categoria
                                })
                            ]
                        }),
                        title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Heading, {
                            className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("mt-4 text-lg font-medium text-mglGray900 tablet:mx-0 tablet:mb-0", (propsAutor && !!propsAutor.text || metaInfo && !!propsMetaInfo) && variants.Title.autorNoMargin.true),
                            style: propsTitle.color ? {
                                color: propsTitle.color
                            } : {},
                            children: news.titulo
                        })
                    ]
                })
            }),
            newsListContainerSpan && newsListContainerSpan.finish()
        ]
    });
}


/***/ }),

/***/ 9879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Titulo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Chip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2384);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9659);



function Titulo(param) {
    var texto = param.texto, color = param.color, urlRedirect = param.urlRedirect, showChip = param.showChip, alignRight = param.alignRight, _headingTag = param.headingTag, headingTag = _headingTag === void 0 ? "h2" : _headingTag, _noPadding = param.noPadding, noPadding = _noPadding === void 0 ? false : _noPadding;
    var titleStyles = "flex items-center text-2xl text-left font-medium";
    var Heading = headingTag;
    var chipProps = {
        black: {
            color: "black",
            border: "black",
            title: "text-mglGray900",
            hover: "black"
        },
        white: {
            color: "white",
            border: "white",
            title: "text-mglGray50",
            hover: "white"
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("flex items-center pb-2 [&>svg]:ml-[5px] [&>svg]:transition-all [&>svg]:duration-200 hover:[&>svg]:ml-[10px]", noPadding && "p-0"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Heading, {
                className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(titleStyles, !alignRight && "mr-2", chipProps[color].title),
                children: texto
            }),
            alignRight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mr-auto"
            }),
            showChip && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Chip__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                texto: "ver tudo",
                color: chipProps[color].color,
                chipSize: "medium",
                posIcon: "chevron-right",
                title: "ver tudo - ".concat(texto),
                borderColor: chipProps[color].border,
                link: urlRedirect,
                hover: chipProps[color].hover
            })
        ]
    });
}


/***/ }),

/***/ 3078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WrapperContent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1080);
/* harmony import */ var _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9642);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9659);




function WrapperContent(param) {
    var children = param.children, backgroundColor = param.backgroundColor, _isOnHeader = param.isOnHeader, isOnHeader = _isOnHeader === void 0 ? false : _isOnHeader, _paddingOnBottom = param.paddingOnBottom, paddingOnBottom = _paddingOnBottom === void 0 ? false : _paddingOnBottom, _paddingOnTop = param.paddingOnTop, paddingOnTop = _paddingOnTop === void 0 ? false : _paddingOnTop, _hasBreadcrumb = param.hasBreadcrumb, hasBreadcrumb = _hasBreadcrumb === void 0 ? false : _hasBreadcrumb, _mobileOnly = param.mobileOnly, mobileOnly = _mobileOnly === void 0 ? false : _mobileOnly, _desktopOnly = param.desktopOnly, desktopOnly = _desktopOnly === void 0 ? false : _desktopOnly, _className = param.className, className = _className === void 0 ? undefined : _className;
    var variants = {
        isOnHeader: {
            true: "isOnHeader [&.isOnHeader]:p-0",
            false: ""
        },
        paddingOnBottom: {
            true: "paddingOnBottom [&.paddingOnBottom]:pb-10",
            false: "pb-0"
        },
        paddingOnTop: {
            true: "paddingOnTop [&.paddingOnTop]:pt-10",
            false: ""
        },
        mobileOnly: {
            true: "flex desktop:hidden",
            false: ""
        },
        desktopOnly: {
            true: "hidden desktop:flex",
            false: ""
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        style: {
            backgroundColor: backgroundColor || _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_2__/* .mglGray.mglGray50 */ .Ce.mglGray50
        },
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("relative flex w-full flex-col flex-wrap content-center justify-center px-0 py-10", variants.isOnHeader[isOnHeader.toString()], variants.paddingOnBottom[paddingOnBottom.toString()], variants.paddingOnTop[paddingOnTop.toString()], variants.mobileOnly[mobileOnly.toString()], variants.desktopOnly[desktopOnly.toString()]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Container__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            hasBreadcrumb: hasBreadcrumb,
            className: className,
            children: children
        })
    });
}


/***/ }),

/***/ 248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WrapperDestaque; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9659);


var LEGACY_BG = {
    ctup: "bg-ctupBlue",
    eletro: "bg-cteletroBlack",
    ctauto: "bg-ctautoRed"
};
function WrapperDestaque(param) {
    var children = param.children, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? "bg-mglGray50" : _backgroundColor, isOnHeader = param.isOnHeader, _themeBg = param.themeBg, themeBg = _themeBg === void 0 ? undefined : _themeBg, _editorialCategory = param.editorialCategory, editorialCategory = _editorialCategory === void 0 ? undefined : _editorialCategory, _paddingOnlyTop = param.paddingOnlyTop, paddingOnlyTop = _paddingOnlyTop === void 0 ? false : _paddingOnlyTop;
    var legacyBg = !themeBg && editorialCategory ? LEGACY_BG[editorialCategory] : undefined;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        style: themeBg ? {
            backgroundColor: themeBg
        } : undefined,
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("flex w-full flex-col flex-wrap content-center justify-center p-0 [&_.swiper-container]:w-full [&_.swiper-container]:py-0", isOnHeader && "p-0 py-0", !isOnHeader && !paddingOnlyTop && "p-0 py-6", legacyBg !== null && legacyBg !== void 0 ? legacyBg : backgroundColor, paddingOnlyTop && "p-0 py-0 pt-10", !paddingOnlyTop && "[&_.swiper-container]:px-6"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "ml-0 w-full",
            children: children
        })
    });
}


/***/ }),

/***/ 804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var PageDataContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
/* harmony default export */ __webpack_exports__["Z"] = (PageDataContext);


/***/ }),

/***/ 6874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bw": function() { return /* binding */ sponsorCategoryData; },
/* harmony export */   "P2": function() { return /* binding */ enableSponsoredCategories; },
/* harmony export */   "PV": function() { return /* binding */ getEditorialCategory; },
/* harmony export */   "Rt": function() { return /* binding */ getSponsoredCategory; },
/* harmony export */   "SU": function() { return /* binding */ getSponsoredCategoryOrTypeWithStringToInternal; },
/* harmony export */   "xu": function() { return /* binding */ isSponsoredOrEditorialToInternal; }
/* harmony export */ });
/* unused harmony exports sponsoredCategoriesUri, getEditorialCategoryWithStringToInternal */
var sponsorCategoryData = {
    tutoriais: [
        {
            url: "https://www.kaspersky.com.br/premium?reseller=br_eg-mf_acq_ona_dis__onl_b2c_canaltech_ban_______&utm_content=banner%7Cgeneric&utm_source=canaltech&utm_medium=display&utm_term=youtube&utm_campaign=",
            title: "Ir para o site do Kaspersky!",
            image: {
                mobile: {
                    src: "https://t.ctcdn.com.br/FnVpzZ0gZiMg1_u-Eskkk_76vHo=/i990769.png",
                    blurhash: "LTS6Plt7%Mt7xufQfQay~qofIUof",
                    height: 30,
                    width: 80
                },
                desktop: {
                    src: "https://t.ctcdn.com.br/FnVpzZ0gZiMg1_u-Eskkk_76vHo=/i990769.png",
                    blurhash: "LTS6Plt7%Mt7xufQfQay~qofIUof",
                    height: 30,
                    width: 80
                }
            }
        }, 
    ],
    smartphone: [
        {
            url: "https://www.motorola.com.br/",
            title: "Ir para o site da Motorola!",
            image: {
                mobile: {
                    src: "https://t.ctcdn.com.br/VeTie34BYV2rLxS_C9-f2E2ddd8=/i1079391.png",
                    blurhash: "LTS6Plt7%Mt7xufQfQay~qofIUof",
                    height: 30,
                    width: 106
                },
                desktop: {
                    src: "https://t.ctcdn.com.br/VeTie34BYV2rLxS_C9-f2E2ddd8=/i1079391.png",
                    blurhash: "LTS6Plt7%Mt7xufQfQay~qofIUof",
                    height: 30,
                    width: 106
                }
            }
        }, 
    ]
};
var enableSponsoredCategories = [
    "tutoriais",
    "smartphone"
];
var sponsoredCategoriesUri = (/* unused pure expression or super */ null && ([
    "tutoriais",
    "smartphone"
]));
var editorialCategoriesCtupUri = [
    "hardware",
    "games",
    "ctup",
    "notebook"
];
var sponsoredCategoriesTutorialsTitle = [
    "Tutoriais"
];
var sponsoredpublicationType = [
    "4"
];
var editorialCategoriesCtupTitle = [
    "Hardware",
    "Games",
    "Notebook"
];
var editorialCategoriesCtAutoTitle = [
    "Ve\xedculos",
    "Carros",
    "Mobilidade Urbana",
    "Ve\xedculos Aut\xf4nomos"
];
var getSponsoredCategory = function(singleCategory) {
    if (singleCategory === "tutoriais") return "tutoriais";
    if (singleCategory === "smartphone") return "smartphone";
    return undefined;
};
var getEditorialCategory = function(singleCategory) {
    if (editorialCategoriesCtupUri.includes(singleCategory)) return "ctup";
    if (singleCategory === "eletro" || singleCategory === "ct-eletro") return "eletro";
    if (singleCategory === "ctauto") return "ctauto";
    return undefined;
};
var isSponsoredOrEditorialToInternal = function(mainCategory, categories) {
    var publicationType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "1";
    if (sponsoredCategoriesTutorialsTitle.includes(mainCategory)) return "sponsored";
    if (editorialCategoriesCtupTitle.includes(mainCategory)) return "editorial";
    if (editorialCategoriesCtAutoTitle.includes(mainCategory)) return "editorial";
    if (mainCategory === "CT Eletro") return "editorial";
    if (categories.some(function(categoria) {
        return sponsoredCategoriesTutorialsTitle.includes(categoria);
    })) return "sponsored";
    if (sponsoredpublicationType.includes(publicationType)) return "sponsored";
    if (categories.some(function(categoria) {
        return editorialCategoriesCtupTitle.includes(categoria);
    })) return "editorial";
    if (categories.some(function(categoria) {
        return editorialCategoriesCtAutoTitle.includes(categoria);
    })) return "editorial";
    if (categories.includes("CT Eletro")) return "editorial";
    return undefined;
};
var getSponsoredCategoryOrTypeWithStringToInternal = function(categories, mainCategory) {
    var publicationType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "1";
    var category = undefined;
    if (mainCategory && sponsoredCategoriesTutorialsTitle.includes(mainCategory)) category = "tutoriais";
    if (sponsoredpublicationType.includes(publicationType)) category = "tutoriais";
    if (categories.some(function(categoria) {
        return sponsoredCategoriesTutorialsTitle.includes(categoria);
    })) category = "tutoriais";
    if (!enableSponsoredCategories.includes(category)) return undefined;
    return category;
};
var getEditorialCategoryWithStringToInternal = function(categories, mainCategory) {
    var category = undefined;
    if (categories.some(function(categoria) {
        return editorialCategoriesCtupTitle.includes(categoria);
    })) category = "ctup";
    if (categories.some(function(categoria) {
        return editorialCategoriesCtAutoTitle.includes(categoria);
    })) category = "ctauto";
    if (categories.includes("CT Eletro")) category = "eletro";
    if (editorialCategoriesCtupTitle.includes(mainCategory)) category = "ctup";
    if (editorialCategoriesCtAutoTitle.includes(mainCategory)) category = "ctauto";
    if (mainCategory === "CT Eletro") category = "eletro";
    return category;
};


/***/ })

}]);